import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, EyeOff, Trash2, Clock } from "lucide-react";

export const ModerationPanel = ({ testid, emptyText, load, approve, remove, renderItem }) => {
  const [items, setItems] = useState([]);

  const refresh = () => load().then(setItems).catch(() => {});
  useEffect(() => { refresh(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const doApprove = async (id, approved) => { await approve(id, approved); refresh(); };
  const doDelete = async (id) => { await remove(id); toast.success("Deleted"); refresh(); };

  const pending = items.filter((i) => !i.approved).length;

  return (
    <div className="space-y-3" data-testid={testid}>
      {pending > 0 && (
        <p className="text-sm text-[var(--gold-hover)] flex items-center gap-1.5" data-testid={`${testid}-pending-count`}>
          <Clock className="w-4 h-4" /> {pending} awaiting your approval
        </p>
      )}
      {items.length === 0 && (
        <p className="text-[var(--text-muted)] text-sm py-10 text-center" data-testid={`${testid}-empty`}>{emptyText}</p>
      )}
      {items.map((it) => (
        <div key={it.id} className="rounded-xl border border-[var(--border)] bg-[var(--card)] p-4 flex items-start justify-between gap-4" data-testid={`${testid}-item-${it.id}`}>
          <div className="min-w-0 flex-1">
            {!it.approved && (
              <span className="inline-flex items-center gap-1 text-xs text-[var(--gold-hover)] mb-1.5"><Clock className="w-3 h-3" /> Pending approval</span>
            )}
            {renderItem(it)}
          </div>
          <div className="flex items-center gap-1 shrink-0">
            {it.approved ? (
              <button onClick={() => doApprove(it.id, false)} title="Hide from site" className="p-2 rounded hover:bg-[var(--surface)]" data-testid={`${testid}-hide-${it.id}`}>
                <EyeOff className="w-4 h-4 text-[var(--text-secondary)]" />
              </button>
            ) : (
              <button onClick={() => doApprove(it.id, true)} title="Approve & show" className="p-2 rounded hover:bg-green-50" data-testid={`${testid}-approve-${it.id}`}>
                <Check className="w-4 h-4 text-green-600" />
              </button>
            )}
            <button onClick={() => doDelete(it.id)} title="Delete" className="p-2 rounded hover:bg-red-50" data-testid={`${testid}-delete-${it.id}`}>
              <Trash2 className="w-4 h-4 text-red-500" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
